/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { GroupThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import { EmailInput } from 'components/common/TextInput';
import Form from 'components/common/Form';
import SubmitFormControls from '../../../common/FormControls/CancelUpdateFormControls';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';
import { LocalText } from "../../common/LocalText";

const LoginEmail = ({ submitEmail, email, updateEmail, isValidEmail, groupName, invalidPhrase, isInvalid, organizationName }) => (
  <GroupThemedContentPanelWithFullHeader isFixedWidth titlePhrase={{ id: 'login.titleGroups.text' }} subTitle={<LocalText text={organizationName}/>}>
    <WhiteCardWithWidePadding>
      <Form>
        <EmailInput
          value={email}
          onChange={updateEmail}
          label={<FormattedMessage id="loginEmail.email.field.label" />}
          autoFocus
          isInvalid={isInvalid}
          invalidHint={invalidPhrase.id  && <FormattedMessage id={invalidPhrase.id} />}
        />

        <SubmitFormControls
          onCancel={null}
          onSubmit={submitEmail}
          isSubmitDisabled={!isValidEmail}
          submitPhrase={{ id: 'nav.next.button.label' }}
        />
      </Form>
    </WhiteCardWithWidePadding>
  </GroupThemedContentPanelWithFullHeader>
);

export default LoginEmail;